export default __webpack_public_path__ + "26795b8897b0b145a230a01c5b162004.png";